import { SvgIconProps } from "@mui/material";
export const ArrowVertical = (props: SvgIconProps) => {
  return (
    <svg
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.82812 0.148438L10 1.32031L5 6.32031L0 1.32031L1.17188 0.148438L5 3.97656L8.82812 0.148438Z"
        fill="#292929"
      />
    </svg>
  );
};
